import React, { useMemo } from 'react';
import { Stack } from 'new/elements/Stack';
import { includeModeTypes } from 'new/components/settings/VendorBuilder/selectTypes';
import { FormBuilder } from 'new/components/settings/VendorBuilder/FormControlBuilder';
import useAuthParamsInjector from 'new/components/settings/VendorBuilder/AuthConfig/useAuthParamsInjector';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';

interface ApiKeyProps {
  index: number;
}

const fields = (index) => [
  {
    type: 'select',
    label: (
      <>
        Where to add api key on API requests? <code>config["api.key.include.mode"]</code>
      </>
    ),
    items: includeModeTypes,
    required: true,
    name: `auth_templates[${index}].config["api.key.include.mode"]`,
  },
  {
    type: 'text',
    required: true,
    label: (
      <>
        API Key Parameter Name <code>config["api.key.auth.key"]</code>
      </>
    ),
    name: `auth_templates[${index}].config["api.key.auth.key"]`,
  },
  {
    type: 'text',
    required: true,
    label: (
      <>
        API Key Parameter Value <code>config["api.key.auth.value"]</code>
      </>
    ),
    name: `auth_templates[${index}].config["api.key.auth.value"]`,
  },
];

const params = (vendor) => [
  {
    configName: 'api.key.auth.value',
    param: {
      name: vendor.name + '.api_key_value',
      display_name: 'API Key Value',
      description: '',
      order: 1,
      data_type: 'string',
      config: {
        required: true,
      },
      secured: true,
    },
  },
];

export const ConfigApiKey = (props: ApiKeyProps) => {
  const { vendor } = useVendorBuilder();
  const { index } = props;

  const keyParams = useMemo(() => params(vendor), [vendor.name]);

  useAuthParamsInjector(keyParams, index);

  const keyFields = useMemo(() => fields(index), [index]);

  return (
    <Stack>
      <FormBuilder fields={keyFields} />
    </Stack>
  );
};
